import { render, staticRenderFns } from "./TipoEsterilizacao.vue?vue&type=template&id=0f39e892&"
import script from "./TipoEsterilizacao.vue?vue&type=script&lang=js&"
export * from "./TipoEsterilizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports